export const NEVER_SCREENSAVER_DELAY_SECONDS = -1;

export const SCREEN_SCREENSAVER_DELAY_OPTIONS = [
  0,
  30,
  60,
  120,
  180,
  240,
  300,
  600,
  1200,
  2400,
  3600,
  NEVER_SCREENSAVER_DELAY_SECONDS,
] as const;

export const formatScreensaverDelayLabel = (seconds: number) => {
  if (seconds === NEVER_SCREENSAVER_DELAY_SECONDS) {
    return "Never";
  }

  if (seconds === 0) {
    return "Immediately";
  }

  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  return `${minutes}m`;
};
